import styled from "styled-components";

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 반투명한 검정색 */
  z-index: 9998; /* 팝업 바로 뒤에 오도록 설정 */
`;

export const PubMoreWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px 20px 50px;
  z-index: 10001;
  background-color: white;
  border-radius: 12px 12px 0px 0px;
`;

export const InfoSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
`;

export const TagRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const TagBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const Tag = styled.span`
  padding: 4px 6px;
  color: var(--Purple-300, #6436e7);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-radius: 16.667px;
  border: 1px solid #e8dcfc;
  white-space: nowrap;
`;

export const CloseButton = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const TitleRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  text-align: center;
`;

export const CafeName = styled.div`
  margin-top: 8px;
  color: #444;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.32px;
`;

export const Address = styled.div`
  margin-top: 4px;
  color: #868686;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: -2%;
`;

export const InfoRow = styled.div`
  margin-top: 4px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 8px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1px;
`;

export const InfoIcon = styled.img`
  filter: grayscale(100%) opacity(50%);
  width: 16px;
  height: 16px;
`;

export const InfoText = styled.span`
  color: #868686;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.28px;
`;

export const MenuWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const MenuItem = styled.div`
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid var(--Black-100, #f0f0f0);
  flex: 1;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  &:hover {
    background-color: #f9f9f9;
  }
`;

export const MenuIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

export const MenuLabel = styled.span`
  color: var(--Black-400, #444);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.28px;
`;
